import type { MouseEvent, ReactNode } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";

const memberBadgeClassName = "member-badge__name";

export interface ContentProps {
  closeIconAriaLabel?: string;
  icon?: ReactNode;
  label?: string;
  onClose?: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const Content = ({
  label,
  icon,
  closeIconAriaLabel = t("remove"),
  onClose,
}: ContentProps) => (
  <>
    {icon}
    <span className={memberBadgeClassName}>{label}</span>
    {onClose && (
      <button
        type="button"
        className="text-default ml-0.5 inline-flex h-4 shrink-0 items-center justify-center focus:text-white"
        onClick={onClose}
        aria-label={closeIconAriaLabel}
      >
        <Icon type="12-close" size={12} />
      </button>
    )}
  </>
);
